/* 🤖 this file was generated by svg-to-ts */
export const matIconTask: {
  name: 'task';
  data: string;
} = {
  name: 'task',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zm-9.18-6.95L7.4 14.46 10.94 18l5.66-5.66-1.41-1.41-4.24 4.24-2.13-2.12z"/></svg>`
};
